export default __webpack_public_path__ + "static/media/day1.7bd22877.png";